module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "radiobutton",
    class: {
      disabled: _vm.isDisabled
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "id": _vm.id,
      "name": _vm.name,
      "disabled": _vm.isDisabled
    },
    domProps: {
      "value": _vm.value,
      "checked": _vm.checked
    },
    on: {
      "change": function($event) {
        _vm.onChange()
      }
    }
  }), _vm._v(" "), _c('label', {
    class: [_vm.ischecked ? 'checked' : ''],
    attrs: {
      "for": _vm.id
    }
  }, [_vm._v(_vm._s(_vm.id))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a67b788","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/radio-button/RadioButton.vue
// module id = 566
// module chunks = 0